export default __webpack_public_path__ + "static/media/integracao_warren_exterior.abe871c7.gif";